/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// inspiration: https://github.com/zoxxx/GDPR-cookie-consent
require('../vendor/cookieconsent.min');

class CookieManagement {
  static initClass() {
    let left;
    this.prototype.activeForAll = false;
    this.prototype.consented = (left = document.cookie.match(/cookieconsent_status=allow/)) != null ? left : {true : false};
    this.prototype.consentQueue = [];
    this.prototype.isEu = false;
  }

  constructor() {
    this.queue = this.queue.bind(this);
    this.onWindowLoad = this.onWindowLoad.bind(this);
    this.processChoice = this.processChoice.bind(this);
    const janOffset = new Date(new Date().getFullYear(), 0, 1).getTimezoneOffset();
    const julOffset = new Date(new Date().getFullYear(), 6, 1).getTimezoneOffset();

    if (this.activeForAll || ((janOffset >= -120) && (janOffset <= 0) && (julOffset < janOffset))) {
      this.isEu = true;
    }
  }

  queue(fn) {
    if (this.isEu && !this.consented) {
      return this.consentQueue.push(fn);
    } else {
      return fn();
    }
  }

  onConsent() {
    return this.consentQueue.forEach(fn => fn());
  }

  onWindowLoad() {
    if (this.isEu && !window.isMobileApp) {
      return window.cookieconsent.initialise({
        onInitialise: this.processChoice,
        onStatusChange: this.processChoice,
        position: "bottom-right",
        palette: {
          popup: {
            background: "#edf2f3",
            link: "#067e81"
          },
          button: {
            background: "#067e81"
          }
        },
        theme: "classic",
        type: "opt-in",
        content: {
          message: "We would like to use cookies to ensure you get the best possible experience.",
          href: "https://punchpass.com/privacy"
        }
      });
    }
  }

  processChoice(status) {
    if (status === 'allow') {
      this.consented = true;
      return this.onConsent();
    } else {
      return this.consented = false;
    }
  }
}
CookieManagement.initClass();

window.cookieManagement = new CookieManagement;
window.addEventListener("load", window.cookieManagement.onWindowLoad);
